import mapaDeRotas from "@/router/caminho-urls";
import axios from "axios";
import {getTokenAuth} from "@/stores/auth";

export async function ConsultaUsuario() {

    try {
        const rota = new mapaDeRotas();
        const isDevEnvironment = process.env.VUE_APP_NODE_ENV === "development";
        const token_base = isDevEnvironment ? await getTokenAuth() : null;
        const config = {
            method: 'GET',
            url: `${rota.rota_api}/usuario/listar-usuario`,
            headers: {
                ...(token_base && { "Authorization": token_base })
            },
        };
        const response = await axios(config)
            .then(response => {
                return response;
            })
            .catch(err => {
                localStorage.removeItem('token');
                localStorage.removeItem('token_username');
                localStorage.removeItem('id');
                localStorage.removeItem('ultima_rota');
                localStorage.removeItem('etapa');
                localStorage.removeItem('tipo_pessoa');
                localStorage.removeItem('nm_celular');
                localStorage.removeItem('estado_civil');
                return err;
            });
        return response;
    } catch (error) {
        console.error("Erro: " + error.message);
    }
}